import { useLocation, useNavigate } from "react-router-dom";
import Slider from "./Slider";
import SavedMenu from "./Saved";
import { normalizePathname } from "../utils/pathname";

export default function SoundList({ handleResetClick, sounds, playMix, gallery, liveGallery }) {
  const location = useLocation();
  const normalizedPath = normalizePathname(location.pathname);
  const pathname = normalizedPath === "/" ? "/playlist" : normalizedPath;
  const navigate = useNavigate();
  return (
    <section className="playlist-section" aria-label="Sound mixes">
      <div className="playlist-toolbar">
        <nav aria-label="Mix library" className="playlist-tabs">
          <button type="button" onClick={() => navigate("/playlist")} className={`mixer-pill ${pathname === "/playlist" ? "is-current" : ""}`} aria-current={pathname === "/playlist" ? "page" : undefined}>Playlists</button>
          <button type="button" onClick={() => navigate("/saved")} className={`mixer-pill ${pathname === "/saved" ? "is-current" : ""}`} aria-current={pathname === "/saved" ? "page" : undefined}>Saved</button>
          <button type="button" onClick={() => navigate("/gallery")} className={`mixer-pill ${pathname === "/gallery" ? "is-current" : ""}`} aria-current={pathname === "/gallery" ? "page" : undefined}>Gallery</button>
          <button type="button" onClick={() => navigate("/live-gallery")} className={`mixer-pill ${pathname === "/live-gallery" ? "is-current" : ""}`} aria-current={pathname === "/live-gallery" ? "page" : undefined}>Live Gallery</button>
        </nav>
        {pathname !== "/live-gallery" && <div className="playlist-actions">
          {pathname !== "/saved" && <button type="button" onClick={() => navigate("/saved?save=true")} className="mixer-pill" aria-label="Save" title="Save mix">Save</button>}
          <button type="button" onClick={handleResetClick} className="mixer-pill" aria-label="Clear" title="Clear mix">Clear</button>
        </div>}
      </div>
      {pathname === "/live-gallery" ? liveGallery : pathname === "/gallery" ? gallery : pathname === "/saved" ? <SavedMenu sounds={sounds} playMix={playMix} /> : <Slider playMix={playMix} />}
    </section>
  );
}
